import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { Environment } from '../../shared/models/environment';
import { AuthService } from '../services/auth.service';
import { GlobalErrorHandlerService } from 'src/app/shared/global-error-handler.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private environment: Environment = Environment.getInstance();
  private handledSessionExpiration = true;

  constructor(
    private authService: AuthService,private globalErrorHandlerService:GlobalErrorHandlerService
  ) {
    this.authService.authenticated$.subscribe((response) => {
      this.handledSessionExpiration = false;
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => { }),
      catchError((error) => {
        this.globalErrorHandlerService.errorHandler(error); 
        switch(error?.error?.error?.message){
          case 'TokenExpired': this.environment.sessionExpiryMessages = "Session Expired.";this.authService.signOut();break;
          case 'FailedToDecode': this.environment.sessionExpiryMessages = "You have logged out due to inactivity.";this.authService.signOut();break;
        }
        return throwError(error);
      })
    );
  }
}
